import * as angular from 'angular';

import type { UIRouter } from '@uirouter/core/lib/router';
import type { Ng1StateDeclaration } from '@uirouter/angularjs/lib/interface';
import { authAppState } from '../App/app.states';
import type { Transition } from '@uirouter/angularjs';
import type { ShellAppInitializerService } from '../Shell/Pandora/services/shell-app.initializer.service';
import type { DashboardFiltersService } from './dashboard-filters.service';
import { DashboardPrintableReportComponent } from './dashboard-printable-report/dashboard-printable-report.component';

export const reportsModule = angular.module('mx.sb.Reports', []).config(reportsModuleConfig).component(DashboardPrintableReportComponent.name, DashboardPrintableReportComponent);

reportsModuleConfig.$inject = ['$uiRouterProvider'];
function reportsModuleConfig($uiRouterProvider: UIRouter) {
	const reportsAppPageState: Ng1StateDeclaration = {
		parent: authAppState.name,
		name: 'reportPage',
		url: '/report/:navigationId?:filters:orientation:includeHeaderFooter:theme:highContrast:headerTitle',
		component: DashboardPrintableReportComponent.name,

		lazyLoad: async function lazyLoadModules(transition: Transition) {
			const $ocLazyLoad = transition.injector().get('$ocLazyLoad');
			const { shellAppModule } = await import(/* webpackChunkName: "shell" */ '../Shell/shell');
			await $ocLazyLoad.inject(shellAppModule.name, {}, true);

			const shellAppInitializerService: ShellAppInitializerService = transition.injector().get('mx.shell.ShellAppInitializerService');

			await shellAppInitializerService.initShellApp({
				applicationProvider: {
					async load() {
						return [
							{
								name: 'Reports',
								title: 'Reports',
								value: '',
								hamletSearchEnabled: false,
								showOperationMonitor: false,
								showPreviewOnSave: true,
							},
						];
					},
				},
				actionProvider: {
					getActions: async () => [],
					checkAvailability: async () => ({ isAvailable: true }),
				},
				navigationProvider: {
					load: async () => [],
				},
			});

			return {};
		},
		params: {
			navigationId: { type: 'string', isOptional: false, value: '' },
			filters: { type: 'string', isOptional: true, value: '' },
			headerTitle: { type: 'string', isOptional: true, value: '' },
			orientation: { type: 'string', isOptional: true, value: 'portrait' },
			includeHeaderFooter: { type: 'bool', isOptional: true, value: false },
			theme: { type: 'string', isOptional: true, value: null },
			highContrast: { type: 'bool', isOptional: true, value: false },
		},
		resolve: {
			navigationId: ['$transition$', ($transition$: Transition) => $transition$.params().navigationId],
			themeId: ['$transition$', ($transition$: Transition) => $transition$.params().theme],
			headerTitle: ['$transition$', ($transition$: Transition) => $transition$.params().headerTitle ?? ''],
			orientation: ['$transition$', ($transition$: Transition) => $transition$.params().orientation ?? 'portrait'],
			includeHeaderFooter: ['$transition$', ($transition$: Transition) => $transition$.params().includeHeaderFooter ?? false],
			isContrastTheme: ['$transition$', ($transition$: Transition) => $transition$.params().highContrast ?? false],
			filters: [
				'$transition$',
				'mx.sb.Dashboard.DashboardFiltersService',
				($transition$: Transition, dashboardFiltersService: DashboardFiltersService) => {
					return dashboardFiltersService.parseFiltersRoute($transition$.params().filters ?? '');
				},
			],
		},
	};

	$uiRouterProvider.stateRegistry.register(reportsAppPageState);
}
